/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from 'react';

import 'semantic-ui-css/semantic.min.css';
import { Box, Menu } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { OhsHrLookup } from 'human-resource/models/OhsHumanResourceModels';
import OhsContractorLookup from 'contractor/models/OhsContractorLookUp';
import OhsUserLocalServices from 'user/OhsUserLocalServices';
import { getModuleName } from 'user/OhsUserServices';

import { returnUniqueCustomLink, returnUniqueLink } from './OhsHrContractorLinkServices';
import { parseOtherDisplayValue } from '../../../../global-services/OhsDataParse';
import { LinkItemFormat } from './OhsLinkModels';

interface Props {
  anchorEl: null | HTMLElement;
  handleMenuClose: () => void;
  ohsHrLookupList: OhsHrLookup[];
  ohsContractorList: OhsContractorLookup[];
  ohsLinkList?: LinkItemFormat[];
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  handleAddLink: (link: any) => void;
  hoveredItem: number;
  handleRefFetch: any;
  handleKeyDownFunc: any;
}
const useStyles = makeStyles()(() => ({
  container: {
    backgroundColor: '#f3f4f5',
    marginTop: '-8px',
    marginBottom: '-8px',
    display: 'block',
  },
  category: { display: 'table-row' },
  moduleType: {
    display: 'table-cell',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '1rem',
    padding: '0.4em 1em',
    fontWeight: 700,
    color: 'rgba(0, 0, 0, 0.4)',
    borderBottom: '1px solid rgba(34, 36, 38, 0.1)',
  },
  moduleResults: {
    display: 'table-cell',
    backgroundColor: '#fff',
    borderLeft: '1px solid rgba(34, 36, 38, 0.15)',
    borderBottom: '1px solid rgba(34, 36, 38, 0.1)',
    width: '28em',
  },
  moduleResult: {
    padding: '0.85714286em 1.14285714em',

    cursor: 'pointer',
    borderBottom: '1px solid rgba(34, 36, 38, 0.1)',
  },
  moduleResultTitle: {
    fontSize: '1rem',
    fontWeight: 700,
  },
  moduleResultDescription: {
    color: 'rgba(0, 0, 0, 0.4)',
    fontSize: '0.92857143em',
  },
}));
export default function SearchResultMenu(props: Props) {
  const user = OhsUserLocalServices.getLocalOhsUser();
  const { classes } = useStyles();
  const [isHovering, setIsHovering] = React.useState('');
  const eleRef = useRef();
  const handleClick = (item: OhsHrLookup | OhsContractorLookup | LinkItemFormat) => {
    props.handleAddLink(item);
    props.setAnchorEl(null);
  };
  const [hoveredItem, setHoveredItem] = React.useState(0);

  useEffect(() => {
    setHoveredItem(props.hoveredItem);
    props.handleRefFetch(eleRef);
  }, [props.hoveredItem, eleRef]);

  return (
    <Box width={400}>
      <Menu
        anchorEl={props.anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        keepMounted
        open={props.anchorEl != null}
        disableAutoFocus
        disableEnforceFocus
        onClose={props.handleMenuClose}
        onKeyDown={props.handleKeyDownFunc}
        slotProps={{
          paper: {
            ref: (ref: any) => {
              eleRef.current = ref;
            },
          },
        }}
      >
        <div className={classes.container}>
          {/* HR */}
          {props.ohsHrLookupList && props.ohsHrLookupList.length > 0 && (
            <div className={classes.category}>
              <div className={classes.moduleType}>{user?.configs.hr?.TITLE}</div>
              <div className={classes.moduleResults}>
                {props.ohsHrLookupList.map((item, index) => (
                  <div
                    className={classes.moduleResult}
                    key={index}
                    onClick={() => {
                      handleClick(item);
                    }}
                    style={{
                      backgroundColor:
                        isHovering === returnUniqueLink(item) || hoveredItem === index
                          ? '#f3f4f5'
                          : '#fff',
                    }}
                    onMouseEnter={() => {
                      setIsHovering(returnUniqueLink(item));
                    }}
                    onMouseLeave={() => {
                      setIsHovering('');
                    }}
                  >
                    <div>
                      <div className={classes.moduleResultTitle}>{item.name}</div>
                      <div className={classes.moduleResultDescription}>
                        <span>{item.businessName}</span>
                        <span>
                          {item.position
                            ? `, ${parseOtherDisplayValue(
                                item.position,
                                item.positionOther as string
                              )}`
                            : ''}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* Contractor */}
          {props.ohsContractorList && props.ohsContractorList.length > 0 && (
            <div className={classes.category}>
              <div className={classes.moduleType}>{user?.configs.contractor?.TITLE}</div>
              <div className={classes.moduleResults}>
                {props.ohsContractorList.map((item, index) => (
                  <div
                    className={classes.moduleResult}
                    key={index}
                    onClick={() => {
                      handleClick(item);
                    }}
                    style={{
                      backgroundColor:
                        isHovering === returnUniqueLink(item) ||
                        hoveredItem - props.ohsHrLookupList.length === index
                          ? '#f3f4f5'
                          : '#fff',
                    }}
                    onMouseEnter={() => {
                      setIsHovering(returnUniqueLink(item));
                    }}
                    onMouseLeave={() => {
                      setIsHovering('');
                    }}
                  >
                    <div>
                      <div className={classes.moduleResultTitle}>{item.businessName}</div>
                      <div className={classes.moduleResultDescription}>
                        {item.contactName}
                        {item.contactEmail ? `, ${item.contactEmail}` : ''}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* Custom */}
          {props.ohsLinkList && props.ohsLinkList.length > 0 && (
            <div className={classes.category}>
              <div className={classes.moduleType}>
                {getModuleName(user?.configs, props.ohsLinkList[0].type)}
              </div>
              <div className={classes.moduleResults}>
                {props.ohsLinkList.map((item, index) => (
                  <div
                    className={classes.moduleResult}
                    key={index}
                    onClick={() => {
                      handleClick(item);
                    }}
                    style={{
                      backgroundColor:
                        isHovering === returnUniqueCustomLink(item) ||
                        hoveredItem - props.ohsHrLookupList.length === index
                          ? '#f3f4f5'
                          : '#fff',
                    }}
                    onMouseEnter={() => {
                      setIsHovering(returnUniqueCustomLink(item));
                    }}
                    onMouseLeave={() => {
                      setIsHovering('');
                    }}
                  >
                    <div>
                      <div className={classes.moduleResultTitle}>{item.name}</div>
                      <div className={classes.moduleResultDescription}>{item.description}</div>
                      <div className={classes.moduleResultDescription}>{item.description2}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* No Result */}
          {(props.ohsHrLookupList == null || props.ohsHrLookupList.length === 0) &&
            (props.ohsContractorList == null || props.ohsContractorList.length === 0) &&
            (props.ohsLinkList == null || props.ohsLinkList.length === 0) && (
              <div style={{ padding: '1em 1em', backgroundColor: '#fff' }}>
                <div
                  style={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 0.87)',
                  }}
                >
                  No Results
                </div>
                <div
                  style={{
                    fontSize: '1rem',
                    color: 'rgba(0, 0, 0, 0.87)',
                  }}
                >
                  Your search returned no results
                </div>
              </div>
            )}
        </div>
      </Menu>
    </Box>
  );
}

SearchResultMenu.defaultProps = {
  ohsLinkList: [],
};
